module.exports = __webpack_public_path__ + "static/media/aulaVirtual.c15738ac.png";